import { CircularProgress } from "@mui/material";
import HtmlView from "component/htmlView/html-view";
import LabelLang, { LabelLangString } from "component/LabelLang/label-lang";
import MainButton from "component/shared/mainButton/MainButton";
import SnackbarModal from "component/shared/snackbar";
import { END_POINTS } from "constants/APIConstant";
import { CALERNDAR_TYPES } from "constants/CalendarConstant";
import { DateFormater } from "functions/dateTimeFormat";
import React from "react";
import { Modal } from "react-bootstrap";
import Collapse from "react-bootstrap/Collapse";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import fetch from "../../../auth/FetchInterceptor.js";

const CalItem = ({
  calendarTypeId,
  date,
  event,
  internationalDay,
  publication,
  openList,
  setOpenList,
  index,
  currentLocale,
  getPeriodic,
  userInfo,
  userPublicationSubscriptions,
  dayCalData,
}) => {
  const intl = useIntl();

  const navigate = useNavigate();

  const [showModal, setShowModal] = React.useState(false);
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const [showFeedback, setShowFeedback] = React.useState(false);
  const handleShowFeedback = () => setShowFeedback(true);
  const handleCloseFeedback = () => setShowFeedback(false);

  const [success, setSuccess] = React.useState(false);
  const [showMessage, setShowMessage] = React.useState("");
  const [buttonSpinner, setButtonSpinner] = React.useState(false);

  const [publicationId, setPublicationId] = React.useState("");

  async function postSubscription() {
    setButtonSpinner(true);

    let subscriptionData = {
      publicationId: publicationId,
      userId: userInfo.id,
    };

    return await fetch
      .post(END_POINTS.PUBLICATION_SUBSCRIPTION, subscriptionData)
      .then((res) => {
        setShowMessage(intl.formatMessage({ id: "successfully-confirm" }));
        setSuccess(true);
        setButtonSpinner(false);
        handleShowFeedback();
        setTimeout(() => {
          handleCloseModal();
        }, 3000);
      })
      .catch((e) => {
        setShowMessage(e.response.data.message);
        setSuccess(false);
        setButtonSpinner(false);
        handleShowFeedback();
      });
  }

  // console.log("Subscriptions: ", userPublicationSubscriptions);

  return (
    <>
      {calendarTypeId == CALERNDAR_TYPES.EVENTS ? (
        <div className="coll-item">
          <div
            className="coll-item-headr"
            onClick={() => {
              var list = [];
              for (let i = 0; i < dayCalData.length; i++) {
                if (index == i) list = list.concat(!openList[index]);
                else list = list.concat([false]);
              }
              setOpenList(list);
            }}
            aria-controls="example-collapse-text"
            aria-expanded={openList[index]}
          >
            <span className={"red"}></span>
            <h6>
              {LabelLangString({
                id: "title",
                currentLocale: currentLocale,
                defaultValue: event?.title,
                translations: event?.eventTranslation,
              })}
            </h6>
            <img
              loading="lazy"
              className={openList[index] ? "open" : "close"}
              src={process.env.PUBLIC_URL + "/image/cursor.svg"}
              alt="cursor-img"
            />
          </div>
          <Collapse in={openList[index]}>
            <div id="example-collapse-text">
              <div className="coll-dateils">
                <p>
                  <FormattedMessage id="description" />:{" "}
                  <LabelLang
                    id="description"
                    defaultValue={event == null ? "" : event.description}
                    translations={event == null ? "" : event.eventTranslation}
                  />
                </p>
                <p>
                  <FormattedMessage id="calendar-agenda" />:{" "}
                  <LabelLang
                    id="agenda"
                    defaultValue={event == null ? "" : event.agenda}
                    translations={event == null ? "" : event.eventTranslation}
                  />
                </p>
                <p>
                  <FormattedMessage id="speaker" />:{" "}
                  <LabelLang
                    id="speaker"
                    defaultValue={event == null ? "" : event.speaker}
                    translations={event == null ? "" : event.eventTranslation}
                  />
                </p>
              </div>
            </div>
          </Collapse>
        </div>
      ) : calendarTypeId == CALERNDAR_TYPES.INTERNATIONAL_DAY ? (
        <div className="coll-item">
          <div
            className="coll-item-headr"
            onClick={() => {
              var list = [];
              for (let i = 0; i < dayCalData.length; i++) {
                if (index == i) list = list.concat(!openList[index]);
                else list = list.concat([false]);
              }
              setOpenList(list);
            }}
            aria-controls="example-collapse-text"
            aria-expanded={openList[index]}
          >
            <span className={"brwn"}></span>
            <h6>
              {LabelLangString({
                id: "title",
                currentLocale: currentLocale,
                defaultValue: internationalDay?.title,
                translations: internationalDay?.internationalDayTranslation,
              })}
            </h6>
            <img
              loading="lazy"
              className={openList[index] ? "open" : "close"}
              src={process.env.PUBLIC_URL + "/image/cursor.svg"}
              alt="cursor-img"
            />
          </div>
          <Collapse in={openList[index]}>
            <div id="example-collapse-text">
              <div className="coll-dateils">
                <p>
                  <FormattedMessage id="description" />:{" "}
                  <LabelLang
                    id="description"
                    defaultValue={
                      internationalDay == null
                        ? ""
                        : internationalDay.description
                    }
                    translations={
                      internationalDay == null
                        ? ""
                        : internationalDay.internationalDayTranslation
                    }
                  />
                </p>
              </div>
            </div>
          </Collapse>
        </div>
      ) : (
        <div className="coll-item">
          <div
            className="coll-item-headr"
            onClick={() => {
              var list = [];
              for (let i = 0; i < dayCalData.length; i++) {
                if (index == i) list = list.concat(!openList[index]);
                else list = list.concat([false]);
              }
              setOpenList(list);
            }}
            aria-controls="example-collapse-text"
            aria-expanded={openList[index]}
          >
            <span className={"blue"}></span>
            <h6>
              {LabelLangString({
                id: "name",
                currentLocale: currentLocale,
                defaultValue: publication?.name,
                translations: publication?.publicationTranslations,
              })}
            </h6>
            <img
              loading="lazy"
              className={openList[index] ? "open" : "close"}
              src={process.env.PUBLIC_URL + "/image/cursor.svg"}
              alt="cursor-img"
            />
          </div>
          <Collapse in={openList[index]}>
            <div id="example-collapse-text">
              <div className="coll-dateils">
                <div className="cont-details">
                  <span>
                    <FormattedMessage id="name" />:
                  </span>
                  <p>
                    <LabelLang
                      id="name"
                      defaultValue={publication == null ? "" : publication.name}
                      translations={
                        publication == null
                          ? ""
                          : publication.publicationTranslations
                      }
                    />
                  </p>
                </div>
                <div className="cont-details">
                  <span>
                    <FormattedMessage id="description" />:
                  </span>
                  <p>
                    <HtmlView
                      id="description"
                      html={LabelLangString({
                        id: "description",
                        currentLocale: currentLocale,
                        defaultValue:
                          publication == null ? "" : publication.description,
                        translations:
                          publication == null
                            ? ""
                            : publication.publicationTranslations,
                      })}
                    />
                  </p>
                </div>
                <div className="cont-details">
                  <span>
                    <FormattedMessage id="periodical" />
                  </span>
                  <p>
                    <LabelLang
                      id="name"
                      defaultValue={
                        publication == null
                          ? ""
                          : getPeriodic(publication.periodicId)?.name
                      }
                      translations={
                        publication == null
                          ? ""
                          : getPeriodic(publication.periodicId).translations
                      }
                    />
                  </p>
                </div>
                <div className="cont-details">
                  <span>
                    <FormattedMessage id="issue-date" />
                  </span>
                  <p>
                    <DateFormater value={date} />
                  </p>
                </div>
                {/* <div className="cont-details">
                          <span>
                            <FormattedMessage id="number" />:
                          </span>
                          <p>
                            {publication == null
                              ? ""
                              : publication.number
                            }
                          </p>
                        </div> */}
                <div className="cont-details">
                  <span>
                    <FormattedMessage id="price" />:
                  </span>
                  <p>
                    {publication == null ? "" : publication.paperPrice}{" "}
                    <FormattedMessage id="egp" />
                  </p>
                </div>

                <div className="button-coll">
                  {/* <a href="#" className="main-btn">
                            <span>
                              {" "}
                              <FormattedMessage id="publication" />
                            </span>
                            <ChevronIcon
                              width={12}
                              height={12}
                              color="#FFFFFF"
                            />
                          </a> */}
                  <MainButton
                    link={`./publications/${publication?.id}`}
                    text={"publication"}
                  />
                  {/* {publication?.hasMetaData && (
                            <MainButton
                              link={LabelLangString({
                                id: "metaDataLink",
                                currentLocale: currentLocale,
                                defaultValue:
                                  publication == null
                                    ? ""
                                    : publication.metaDataLink,
                                translations:
                                  publication == null
                                    ? ""
                                    : publication.publicationTranslation,
                              })}
                              text={"metadata"}
                            />
                          )} */}
                  {/* <a href="#" className="main-btn">
                            <span>
                              {" "}
                              <FormattedMessage id="metadata" />
                            </span>
                            <ChevronIcon
                              width={12}
                              height={12}
                              color="#FFFFFF"
                            />
                          </a> */}
                </div>
                {userInfo?.token !== null ? (
                  !userPublicationSubscriptions?.some(
                    (item) => publication?.id === item.publicationId
                  ) ? (
                    <div className="chack-box">
                      <label htmlFor="send-email">
                        <input
                          type="checkbox"
                          name="send-email"
                          id="send-email"
                          onChange={(e) => {
                            if (e.target.checked) {
                              userInfo.id
                                ? handleShowModal()
                                : navigate("../login");
                            }
                          }}
                        />
                        <span>
                          <FormattedMessage id="send-email" />
                        </span>
                      </label>

                      <Modal
                        style={{ zIndex: "99999" }}
                        show={showModal}
                        onShow={() => {
                          setPublicationId(publication?.id);
                        }}
                        onHide={() => {
                          handleCloseModal();
                          setPublicationId("");
                        }}
                        centered
                      >
                        <Modal.Header style={{ padding: "1.5rem" }} closeButton>
                          <Modal.Title className="w-100">
                            <h6 className="fw-bold mb-0">
                              {intl.formatMessage({
                                id: "confirm",
                              })}
                            </h6>
                          </Modal.Title>
                        </Modal.Header>

                        <Modal.Body
                          style={{
                            padding: "1.5rem",
                            textAlign: "center",
                          }}
                        >
                          <h6 className=" fw-semibold mb-4">
                            {intl.formatMessage({
                              id: "confirmSendNotificationToEmail",
                            })}
                          </h6>
                          <button
                            className="main-btn mx-auto"
                            onClick={postSubscription}
                            disabled={buttonSpinner ? true : false}
                          >
                            <span className="fw-bold">
                              {buttonSpinner ? (
                                <CircularProgress
                                  sx={{ color: "#fff" }}
                                  size={26}
                                />
                              ) : (
                                <FormattedMessage id="confirm" />
                              )}
                            </span>
                          </button>
                        </Modal.Body>
                      </Modal>

                      {/* feedback */}
                      <SnackbarModal
                        open={showFeedback}
                        onClose={handleCloseFeedback}
                        severity={success ? "success" : "error"}
                        message={showMessage}
                      />
                    </div>
                  ) : (
                    <div className="p-2 fw-bold">
                      <FormattedMessage id="already-suscribed" />
                    </div>
                  )
                ) : null}
              </div>
            </div>
          </Collapse>
        </div>
      )}
    </>
  );
};

export default CalItem;
